import { Injectable } from '@angular/core';
import { ChargingStationConfig } from 'src/app/modules/evc-small-biz/stores/small-biz-store.model';
import { SmallBizStoreService } from 'src/app/modules/evc-small-biz/stores/small-biz-store.service';

@Injectable()
export class ChargingStationInputService {
  constructor(private store: SmallBizStoreService) {}

  public getInputModel(): ChargingStationConfig {
    return this.store.model.chargingStationConfig;
  }

  public add(config: ChargingStationConfig) {
    this.store.setChargingStationConfig(config);
  }
}
